module.exports = ".glyphicon-chevron-right:hover, .glyphicon-chevron-left:hover{\n  cursor: pointer;\n  color: #40A9F5;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/t2-us-register-hospitals/us-register-hospitals.component.css
// module id = ./src/app/t2-us-register-hospitals/us-register-hospitals.component.css
// module chunks = us-register-hospitals.module